import { render, staticRenderFns } from "./intellectual-property.vue?vue&type=template&id=0fc83c12&scoped=true"
import script from "./intellectual-property.vue?vue&type=script&lang=js"
export * from "./intellectual-property.vue?vue&type=script&lang=js"
import style0 from "./intellectual-property.vue?vue&type=style&index=0&id=0fc83c12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc83c12",
  null
  
)

export default component.exports